export const buildFullTree = (node) => ({
  id: node.id,
  children: (node.children || []).map(buildFullTree),
});

export const isNodeSelected = (tree, id) => {
  return tree.some((n) => n.id === id || isNodeSelected(n.children || [], id));
};

export const removeNode = (tree, id) => {
  return tree
    .filter((n) => n.id !== id)
    .map((n) => ({
      ...n,
      children: removeNode(n.children || [], id),
    }));
};

export const toggleNode = (tree, node) => {
  // If selected → remove
  if (isNodeSelected(tree, node.id)) {
    return removeNode(tree, node.id);
  }

  // If not selected → add FULL subtree
  return [...tree, buildFullTree(node)];
};

// flatten API tree → { id: name }
export const buildIdNameMap = (list = []) => {
  const map = {};

  const walk = (nodes = []) => {
    nodes &&
      nodes.forEach((node) => {
        map[node.id] = node.name;
        if (node.children?.length) {
          walk(node.children);
        }
      });
  };

  list.forEach((category) => {
    walk(category.items || []);
  });

  return map;
};

// extract selected IDs from selected tree
export const extractSelectedIds = (tree = {}) => {
  const ids = new Set();

  const walk = (nodes = []) => {
    nodes.forEach((node) => {
      ids.add(node.id);
      if (node.children?.length) {
        walk(node.children);
      }
    });
  };

  Object.values(tree).forEach((categoryTree) => {
    walk(categoryTree);
  });

  return [...ids];
};
